<template>
  <section class="bg-indonesia">
    <div class="gap-8 items-center py-2 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 xl:gap-16 sm:py-4 lg:px-6 ">


      <nuxt-img
          class="mb-4 w-full lg:mb-0 rounded-lg"
          width="584"
          height="389"
          loading="lazy"
          format="webp"
          sizes="sm:440px  md:100vw lg:100vw xl:584px"
          :alt="imageAlt"
          :src="image"
      ></nuxt-img>


      <div class="text-gray-500 dark:text-gray-400 sm:text-lg">


        <div class="py-8 mb-6">
          <div class="flex">
            <div>
              <p class="mb-2 text-xl font-medium leading-tight text-gray-900" v-html="description1">
              </p>

            </div>
          </div>
          <div class="flex pt-8">
            <div>
              <p class="mb-2 text-xl font-medium leading-tight text-gray-900" v-html="description2">


              </p>

            </div>
          </div>
          <div class="flex pt-8">
            <div>
              <p class="mb-2 text-xl font-medium leading-tight text-gray-900" v-html="description3">



              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

defineProps({
  image: {
    type: String,
    default: 'assets/images/sips-6-box.jpg',
  },
  imageAlt: {
    type: String,
    default: 'seassonal sips',
  },
  description1: {
    type: String,
    default: 'It\'s a chilly winter morning, and you\'re wrapped in a plush blanket, gazing out at the snowflakes gently falling from the sky. You take a sip of your coffee, and it\'s as if you\'ve just bitten into a gingerbread cookie—warm, spicy, and oh-so-comforting. Fast-forward to spring, and each sip of your morning brew is a burst of lavender and honey, as rejuvenating as the season itself.',
  },
  description2: {
    type: String,
    default: 'Imagine not having to say goodbye to the flavors that make each season special. What if you could have a year-round journey of taste where each cup is a celebration of the season\'s most cherished moments? We\'ve got you covered, from the cozy spices of winter to the refreshing zest of summer.',
  },
  description3: {
    type: String,
    default: 'Introducing our Seasonal Sips Club Bundle—a curated selection of our finest flavored coffees, delivered to your doorstep, just in time for each new season. Experience the rich tapestry of Pumpkin Spice in the fall, the indulgence of Chocolate Raspberry Truffle in the winter, the awakening of Honey Lavender in the spring, and the playfulness of Mint Cookies and Cream in the summer. And that\'s just the beginning.',
  },

})

defineBuilderComponent({
    friendlyName: "SipsBoxSeason",
    canHaveChildren: true,
    inputs: [
        {
            name: "image",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "assets/images/sips-6-box.jpg"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "seassonal sips"
        },
        {
            name: "description1",
            type: "richText",
            defaultValue: "It's a chilly winter morning, and you're wrapped in a plush blanket, gazing out at the snowflakes gently falling from the sky. You take a sip of your coffee, and it's as if you've just bitten into a gingerbread cookie—warm, spicy, and oh-so-comforting. Fast-forward to spring, and each sip of your morning brew is a burst of lavender and honey, as rejuvenating as the season itself."
        },
        {
            name: "description2",
            type: "richText",
            defaultValue: "Imagine not having to say goodbye to the flavors that make each season special. What if you could have a year-round journey of taste where each cup is a celebration of the season's most cherished moments? We've got you covered, from the cozy spices of winter to the refreshing zest of summer."
        },
        {
            name: "description3",
            type: "richText",
            defaultValue: "Introducing our Seasonal Sips Club Bundle—a curated selection of our finest flavored coffees, delivered to your doorstep, just in time for each new season. Experience the rich tapestry of Pumpkin Spice in the fall, the indulgence of Chocolate Raspberry Truffle in the winter, the awakening of Honey Lavender in the spring, and the playfulness of Mint Cookies and Cream in the summer. And that's just the beginning."
        }
    ]
});
</script>